import starImg from "./img/icon-star.svg";
import Questions from "./components/Questions";
import data from "./data";

const App = () => {
  return (
    <div className="project-wrapper">
      <section className="card">
        <div className="heading-main">
          <img src={starImg} alt="" />
          <h1>FAQs</h1>
        </div>
        <div>
          {data.map((oneQuestion) => {
            return <Questions key={oneQuestion.id} {...oneQuestion} />;
          })}
        </div>
      </section>
    </div>
  );
};

export default App;
